import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-sizing-edit-dialog',
  templateUrl: './sizing-edit-dialog.component.html',
  styleUrl: './sizing-edit-dialog.component.scss',
  standalone: false
})
export class SizingEditDialogComponent {
  saveEnabled = false;
  originalSections: any;
  constructor(public dialogRef: MatDialogRef<SizingEditDialogComponent>,@Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {
    this.originalSections = JSON.parse(JSON.stringify(this.data.sections));

    this.data.sections.forEach(section => {
      section.metrics.forEach(metric => {
        if (typeof metric.value === 'string' && metric.value.includes('G')) {
          metric.isMemory = true;
          metric.value = Number(metric.value.replace('G', ''));
        }
      });
    });
  }

  checkForChanges() {
  const hasChanges = this.data.sections.some((section, i) => {
    const originalSection = this.originalSections[i];
 
    return section.metrics.some((metric, j) => {
      let currentValue = metric.value;
      let originalValue = originalSection.metrics[j].value;
 
      if (metric.isMemory) {
        currentValue = Number(currentValue);
        originalValue = Number(String(originalValue).replace('G', ''));
      }

      else if (metric.type === 'integer' || metric.type === 'number') {
        currentValue = Number(currentValue);
        originalValue = Number(originalValue);
      }

      else {
        currentValue = String(currentValue);
        originalValue = String(originalValue);
      }
 
      return currentValue !== originalValue;
    });
  });
 
  const hasErrors = this.data.sections.some((section: any) =>
    section.metrics.some((m: any) => m.error)
  );
 
  this.saveEnabled = hasChanges && !hasErrors;
}

  increment(metric: any) {
    metric.value = Math.max(0, Number(metric.value) || 0) + 1;
    this.validateMetric(metric);
    this.checkForChanges();
  }

  decrement(metric: any) {
    metric.value = Math.max(0, (Number(metric.value) || 0) - 1);
    this.validateMetric(metric);
    this.checkForChanges();
  }

  previousValue(metric: any) {
  metric.previousValue = metric.value;
  this.checkForChanges();
}

   formatMemory(metric: any): void {
  const value = (metric.value || '').toString().trim().toUpperCase();

  const validPattern = /^(\d+)(M|G)$/;

  if (validPattern.test(value)) {
    metric.value = value;
  } else {
    metric.value = metric.previousValue || metric.value;
  }
}

  save() {
    const updatedSections = this.data.sections.map((section: any) => ({
    ...section,
    metrics: section.metrics.map((metric: any) => {
      if (metric.isMemory) {
        return {
          ...metric,
          value: `${metric.value}G`
        };
      }
      return metric;
    })
  }));
      this.dialogRef.close(updatedSections);
  }

  cancel() {
    this.dialogRef.close();
  }

  /**
   * Validates metric value against min and max limits and shows error if exceeded.
   * @param metric 
   */
  validateMetric(metric: any) {
    const value = Number(metric.value);
    const minNum = metric.min ? Number(metric.min) : undefined;
    const maxNum = metric.max ? Number(metric.max) : undefined;
    const isBelowMin = minNum && value < minNum;
    const isAboveMax = maxNum && value > maxNum;
    if (isBelowMin && isAboveMax) {
      metric.error = `Must be between minimum (${minNum}) and maximum (${maxNum})`;
    } else if (isBelowMin) {
      metric.error = `Must be &ge; ${minNum}`;
    } else if (isAboveMax) {
      metric.error = `Must be &le; ${maxNum}`;
    } else {
      metric.error = null;
    }
    // check if any metric has error
    this.checkForChanges();
  }
}
